export const FETCH_USER = 'FETCH_USER';
export const CHECK_SMS_KEY = 'CHECK_SMS_KEY';
export const CREATE_USER = 'CREATE_USER';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const SEND_SMS_KEY = 'SEND_SMS_KEY';
export const UPDATE_MOBILE = 'UPDATE_MOBILE';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
